// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale from "../helper/scaling";

import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 1050px;
  padding: 0 calc(50% - 525px);
  float: left;

  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    padding: 0 25px;
  }
  @media (max-width: 700px) {
    margin: 15px;
    width: calc(100% - 30px);
    padding: 0;
  }
`;

const Inner = styled.div`
  width: 100%;
  float: left;

  position: relative;
`;

const Left = styled.div`
  width: calc(55% - 15px);
  float: left;

  @media (max-width: 700px) {
    width: calc(100% - 16px);
    float: left;
    display: flex;
    flex-direction: column;
    margin: 8px;
  }
`;

const Right = styled.div`
  width: calc(45% - 15px);
  height: 100%;

  position: absolute;
  bottom: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 700px) {
    width: 100%;
    position: relative;
    float: left;
  }
`;
const RightInner = styled.div`
  width: 100%;
`;

const SandwichImage = styled.img`
  width: 100%;
  @media (max-width: 700px) {
    order: 1;
    width: 80%;
    margin-left: 20%;
    margin-bottom: 23px;
    :first-child {
      margin-right: 20%;
      margin-left: 0;
      flex-grow: 0;
    }
  }
`;

const Body = styled.div`
  padding-left: 25px;
  margin: 105px 80px 105px 0;

  border-left: solid 3px #ff5368;
  background-color: white;

  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.3px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    padding-left: ${scale(1100, 767, 25, 17, "vw")};
    margin: ${scale(1100, 767, 105, 90, "vw")} ${scale(1100, 767, 80, 70, "vw")}
      ${scale(1100, 767, 105, 90, "vw")} 0;

    font-size: ${scale(1100, 767, 18, 12, "vw")};
    line-height: ${scale(1100, 767, 18 * 1.67, 12 * 1.75, "vw")};
    letter-spacing: ${scale(1100, 767, 1.3, 0.8, "vw")};
  }
  @media (max-width: 700px) {
    order: 2;

    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 0.8px;

    padding-left: 17px;
    width: calc(100% - 20px);

    margin: 15px 0;
  }
`;

class SetImageStack extends Component {
  render() {
    let first = this.props.set[0];
    let items = [];
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i]);
    }
    let image1 = "";
    let image2 = "";
    if (first.images) {
      if (first.images.intro && first.images.intro.url)
        image1 = first.images.intro.url;
      if (first.images.main && first.images.main.url)
        image2 = first.images.main.url;
    }
    return (
      <Wrapper>
        <Inner>
          <Left>
            <SandwichImage src={image1} />
            <Body dangerouslySetInnerHTML={{ __html: first.body }} />
            <SandwichImage src={image2} />
          </Left>
          <Right>
            <RightInner>
              {items.map(item => <Image key={item.id} content={item} />)}
            </RightInner>
          </Right>
        </Inner>
      </Wrapper>
    );
  }
}

export default SetImageStack;

const Item = styled.img`
  width: 100%;
  margin: 20px 0;
  @media (max-width: 700px) {
    width: calc(50% - 16px);
    :last-child {
      width: calc(100% - 16px);
    }
    margin: 8px;
  }
`;

class Image extends ArticleAbstract {
  render() {
    return <Item {...this.link()} src={this.imageUrl()} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/SetImageStack.js